import React from 'react'

type PropsT = {
  className?: string
  fillColor?: string
}

// Four-point sparkle. Path/viewBox mirror ordering-ui's
// RecoveryChat/ChatOfferCard fallback icon exactly — used by the RecoveryAI
// simulator's chat-transcript reward card (SandboxRewardCard, variant="chat")
// when the reward has no image.
const Sparkle: React.FC<PropsT> = props => {
  const { className, fillColor = 'currentColor' } = props

  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill={fillColor}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      data-testid="sparkle-icon"
    >
      <path d="M12 2c.6 5.2 2.8 7.4 8 8-5.2.6-7.4 2.8-8 8-.6-5.2-2.8-7.4-8-8 5.2-.6 7.4-2.8 8-8z" />
    </svg>
  )
}

export default Sparkle
